const INSTALLATION_ID_RE =
  /^[0-9a-f]{8}-[0-9a-f]{4}-4[0-9a-f]{3}-[89ab][0-9a-f]{3}-[0-9a-f]{12}$/i;
const PUSH_REF_RE = /^[a-f0-9]{32}$/;
const TOKEN_RE = /^[A-Za-z0-9:_\-.]{32,4096}$/;
const REGISTER_INTENTS = new Set(['enroll', 'renew']);
const CLIENT_OPERATION_ID_RE =
  /^[0-9a-f]{8}-[0-9a-f]{4}-[1-5][0-9a-f]{3}-[89ab][0-9a-f]{3}-[0-9a-f]{12}$/i;

function assertExactKeys(src, allowed) {
  for (const key of Object.keys(src || {})) {
    if (!allowed.has(key)) throw new Error(`Unknown field: ${key}`);
  }
}

export function buildRegisterAdminProspectPushDeviceRequest(input = {}) {
  const src = input && typeof input === 'object' ? input : {};
  assertExactKeys(
    src,
    new Set([
      'installationId',
      'token',
      'locale',
      'intent',
      'expectedRegistrationGeneration',
      'clientOperationId',
    ]),
  );
  const installationId =
    typeof src.installationId === 'string' ? src.installationId.trim() : '';
  if (!INSTALLATION_ID_RE.test(installationId)) {
    throw new Error('installationId is invalid.');
  }
  const token = typeof src.token === 'string' ? src.token.trim() : '';
  if (!TOKEN_RE.test(token)) {
    throw new Error('token is invalid.');
  }
  const locale = src.locale == null || src.locale === '' ? 'fr' : src.locale;
  if (locale !== 'fr' && locale !== 'en') {
    throw new Error('locale is invalid.');
  }
  const intent = src.intent == null || src.intent === '' ? 'enroll' : src.intent;
  if (!REGISTER_INTENTS.has(intent)) {
    throw new Error('intent is invalid.');
  }
  const out = { installationId, token, locale, intent };
  if (src.expectedRegistrationGeneration != null && src.expectedRegistrationGeneration !== '') {
    const gen = Number(src.expectedRegistrationGeneration);
    if (!Number.isInteger(gen) || gen < 1) {
      throw new Error('expectedRegistrationGeneration is invalid.');
    }
    out.expectedRegistrationGeneration = gen;
  }
  if (intent === 'renew' && out.expectedRegistrationGeneration == null) {
    throw new Error('expectedRegistrationGeneration is required for renew.');
  }
  if (src.clientOperationId != null && src.clientOperationId !== '') {
    const id = typeof src.clientOperationId === 'string' ? src.clientOperationId.trim() : '';
    if (!CLIENT_OPERATION_ID_RE.test(id)) {
      throw new Error('clientOperationId is invalid.');
    }
    out.clientOperationId = id;
  }
  return out;
}

export function buildUnregisterAdminProspectPushDeviceRequest(input = {}) {
  const src = input && typeof input === 'object' ? input : {};
  assertExactKeys(src, new Set(['installationId', 'expectedRegistrationGeneration']));
  const installationId =
    typeof src.installationId === 'string' ? src.installationId.trim() : '';
  if (!INSTALLATION_ID_RE.test(installationId)) {
    throw new Error('installationId is invalid.');
  }
  const out = { installationId };
  if (src.expectedRegistrationGeneration != null && src.expectedRegistrationGeneration !== '') {
    const gen = Number(src.expectedRegistrationGeneration);
    if (!Number.isInteger(gen) || gen < 1) {
      throw new Error('expectedRegistrationGeneration is invalid.');
    }
    out.expectedRegistrationGeneration = gen;
  }
  return out;
}

export function buildGetAdminProspectPushDeviceStatusRequest(input = {}) {
  const src = input && typeof input === 'object' ? input : {};
  assertExactKeys(src, new Set(['installationId']));
  const installationId =
    typeof src.installationId === 'string' ? src.installationId.trim() : '';
  if (!INSTALLATION_ID_RE.test(installationId)) {
    throw new Error('installationId is invalid.');
  }
  return { installationId };
}

export function buildResolveAdminProspectPushRefRequest(input = {}) {
  const src = input && typeof input === 'object' ? input : {};
  assertExactKeys(src, new Set(['ref']));
  const ref = typeof src.ref === 'string' ? src.ref.trim() : '';
  if (!PUSH_REF_RE.test(ref)) {
    throw new Error('ref is invalid.');
  }
  return { ref };
}
